export enum RuleEngineConditionTypeEnum {
  Or = 'Or',
  And = 'And'
}
